import { useEffect } from 'react';

import type { UseWarehouseOperationsEffectsProps } from '@app/pages/Warehouses/WarehouseOperations/types';

export const useWarehouseOperationsEffects = ({
  filtersListsHandler,
  searchProductOperationsHandler,
}: UseWarehouseOperationsEffectsProps) => {
  useEffect(() => {
    filtersListsHandler();
  }, [filtersListsHandler]);

  useEffect(() => {
    searchProductOperationsHandler();
  }, [searchProductOperationsHandler]);
};
